import React from "react";
import './About.css';

const AboutUs = () => {
    return (
        <div className="row">
            <div className="col-2 leftcol">
                
            </div>
            <div className="col-8 middlecol">
                
            </div>
            <div className="col-2 rightcol">
                
            </div>
        </div>
    );
};

export default AboutUs;